import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="eb-container max-w-lg py-24 text-center">
      <div className="eb-card p-10">
        <XCircle className="w-14 h-14 text-slate-500 mx-auto mb-4" />
        <h1 className="font-head text-2xl font-bold">Zahlung abgebrochen</h1>
        <p className="text-slate-400 mt-2">Deine Buchung ist weiterhin reserviert. Du kannst die Zahlung jederzeit abschließen.</p>
        <Link to="/dashboard" className="eb-btn-primary mt-6" data-testid="cancel-dashboard-btn">Zu meinen Buchungen</Link>
      </div>
    </div>
  );
}
